import { bugsnagLogger } from "./adapters/bugsnag.js";
import { dataLayerLogger } from "./adapters/datalayer.js";
function setDefaultLoglevel(logParams) {
  if (!logParams.logLevel) {
    logParams.logLevel = logParams.error ? "error" : "warning";
  }
  return logParams;
}
function setDefaultNameOnError(logParams) {
  if (logParams.error?.name && !logParams.name) {
    logParams.name = logParams.error.name;
  }
  return logParams;
}
function setDefaultMessageOnError(logParams) {
  if (logParams.error?.message && !logParams.message) {
    logParams.message = logParams.error.message;
  }
  return logParams;
}
const allowedRequestHeaders = [
  "host",
  "user-agent",
  "referer",
  "accept",
  "accept-language",
  "content-type",
  "x-forwarded-host",
  "x-forwarded-proto"
];
function pickAllowedRequestHeaders(headers) {
  return Object.fromEntries(
    Object.entries(headers).filter(([header]) => allowedRequestHeaders.includes(header.toLowerCase()))
  );
}
function setRequestHeaders(logParams, headers) {
  if (headers) {
    try {
      logParams.metadata = {
        ...logParams.metadata,
        request: {
          ...logParams.metadata?.request,
          headers: pickAllowedRequestHeaders(headers)
        }
      };
    } catch {
      return logParams;
    }
  }
  return logParams;
}
function setRequestUrl(logParams, url) {
  if (url) {
    try {
      logParams.metadata = {
        ...logParams.metadata,
        request: {
          ...logParams.metadata?.request,
          url
        }
      };
    } catch {
      return logParams;
    }
  }
  return logParams;
}
function setIgnoreOptions(logParams, ignoreOptions) {
  logParams.ignore = ignoreOptions;
  return logParams;
}
function containsIgnoreRequestHeaders(logParams, requestHeaders) {
  const ignoreHeaders = logParams.ignore?.headers || [];
  if (!ignoreHeaders.length) return false;
  const headers = [...Object.keys(requestHeaders || {}), ...Object.keys(logParams.metadata?.request?.headers || {})];
  return headers.some((header) => ignoreHeaders.includes(header));
}
export default function log(context, logParams) {
  logParams = setDefaultNameOnError(logParams);
  logParams = setDefaultMessageOnError(logParams);
  logParams = setDefaultLoglevel(logParams);
  logParams = setRequestUrl(logParams, context.requestUrl);
  logParams = setRequestHeaders(logParams, context.requestHeaders);
  logParams = setIgnoreOptions(logParams, context.ignoreOptions);
  if (containsIgnoreRequestHeaders(logParams, context.requestHeaders)) return;
  if (context.stage !== "production") console.log(logParams);
  bugsnagLogger(logParams, context.bugsnagClient);
  dataLayerLogger(logParams);
}
